// extracted by mini-css-extract-plugin
export default {"container":"PhotoCropper_container__pVaKo","wrapper":"PhotoCropper_wrapper__Ka8jx","control":"PhotoCropper_control__NnnxH"};